import SaleRequests from "../../../../requests/sale-requests"
import NRTFormContainer from "../../../../components/_common/_form/_containers/FormContainer"
import NRTVerticalStack from "../../../../components/_common/_containers/VerticalStack"
import NRTSaleActionBar from "../../../../components/_sale/ActionButtonBar"
import Fade from "../../../../components/_common/_transitions/Fade"
import React, {Component} from 'react'
import qs from "qs"


class CredCardConfirmationReturn extends Component {

    state = {
        awaitingGetSaleDataResponse: true,
        ivaCode: null,
        payPalPaymentID: null,
        payPalPayerID: null,
        payerName: null
    }


    componentWillMount() {
        this.syncStateWithRouteAndSaleData()
    }


    /** Captura da URL parametros para o estado da aplicacao. */
    syncStateWithRouteAndSaleData() {

        // Captura dados da URL
        const queryParams = qs.parse(this.props.location.search);

        console.log(queryParams)
        const {
            iva_code,
            paymentId,
            PayerID

        } = queryParams

        // Atualiza state
        const newState = {
            ivaCode: iva_code,
            payPalPaymentID: paymentId || null,
            payPalPayerID: PayerID || null
        }

        this.setState(newState, this.putSalePayerInState)
    }

    /** Captura nome do comprador && finaliza transacao via Paypal (se necessario). */
    async putSalePayerInState() {

        const saleData = await SaleRequests.getSaleData(this.state.ivaCode)

        // Conclui venda via PayPal (se necessario)
        if (!!this.state.payPalPaymentID && !!this.state.payPalPayerID) {
            await SaleRequests.finishPayPalSale(this.state.ivaCode, this.state.payPalPaymentID, this.state.payPalPayerID)
        }

        // Conclui busca por nome do comprador
        this.setState({
            awaitingGetSaleDataResponse: false,
            payerName: saleData.payerPersonName
        })
    }


    render() {

        const {
            payerName,
            awaitingGetSaleDataResponse

        } = this.state

        return (

            <div style={{padding:'3rem'}}>
                <NRTFormContainer title={'Obrigado pela compra'}>
                    <NRTVerticalStack fractions={[1, 1]}>

                        {/*Agradecimento*/}
                        <div style={{position: 'relative', minHeight: '15rem'}}>
                            <Fade
                                in={!awaitingGetSaleDataResponse}
                                delay={150}
                                style={{
                                    position: 'absolute',
                                    top: '8rem',
                                    margin: '0 auto',
                                    width: '100%',
                                    textAlign: 'center'
                                }}
                            >
                                <div>
                                    <h3>PARABÉNS, {payerName}.</h3>
                                    <h4>Obrigado! Sua inscrição foi cadastrada com sucesso.</h4>
                                </div>
                            </Fade>
                        </div>

                        {/*Btn: Finalizar compra*/}
                        <NRTSaleActionBar
                            loading={awaitingGetSaleDataResponse}
                            onClick={() => this.props.history.push('/') }
                            buttonLabel={awaitingGetSaleDataResponse ? "Aguarde" : "Voltar ao Início"}
                        />

                    </NRTVerticalStack>
                </NRTFormContainer>
            </div>
        )
    }
}


CredCardConfirmationReturn.defaultProps = {}
CredCardConfirmationReturn.propTypes = {}


export default CredCardConfirmationReturn



// WEBPACK FOOTER //
// ./src/_pages/Sale/_partials/CredCardConfirmationReturn/index.js